const Counter = (target) => {
  const plus = target.querySelector(".button__counter--add");
  const minus = target.querySelector(".button__counter--minus");
  const input = target.querySelector("input");

  const method = {
    init: () => {
      plus.addEventListener("click", method.onAdd);
      minus.addEventListener("click", method.onMinus);
    },

    onAdd: (e: Event) => {
      e.preventDefault();
      const currentVal = parseInt(input.value, 10);
      input.value = currentVal + 1;
    },

    onMinus: (e: Event) => {
      e.preventDefault();
      const currentVal = parseInt(input.value, 10);
      if (currentVal > 1) {
        input.value = currentVal - 1;
      }
    },
  };

  method.init();
};

export default Counter;
